module.exports = __webpack_public_path__ + "static/logo-b86231ad97a3a604ad469b00d354e39d.svg";